import { FaRulerCombined, FaWeightHanging } from "react-icons/fa";

export const containerSpecs = [
  {
    title: " Standard 20ft Container",
    image: "/containspec/standard20.webp",
    details: [
      { label: "Inside Length",value: "5.900 m / 19'4''", icon: FaRulerCombined },
      { label: "Inside Width",  value: "2.350 m / 7'8''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.393 m / 7'10''", icon: FaRulerCombined },
      { label: "Door width", value: "2.342 m / 7'8''", icon: FaRulerCombined },
      { label: "Door Height",  value: "2.280 m / 7'6''", icon: FaRulerCombined },
       { label: "capacity",value: "33.2 Cu.m / 1,172 Cft", icon: FaWeightHanging },
      { label: "Tare Weight", value: "2,230 Kgs / 4,916 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "21,770 Kgs / 47,900 Lbs", icon: FaWeightHanging },
     
    ],
  },

  {
    title: " Standard 40ft Container",
    image: "/containspec/standard40.webp",
    details: [
      { label: "Inside Length", value: "12.036 m / 39'5''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.350 m / 7'8''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.392 m / 7'10''", icon: FaRulerCombined },
      { label: "Door width", value: "2.340 m / 7'8''", icon: FaRulerCombined },
      { label: "Door Height", value: "2.280 m / 7'6''", icon: FaRulerCombined },
      { label: "capacity", value: "67.7 Cu.m / 2,390 Cft", icon: FaWeightHanging },
      { label: "Tare Weight", value: "3,700 Kgs / 8.160 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo",value: "26,780 Kgs / 59,040 Lbs", icon: FaWeightHanging },
      
    ],
  },

  {
    title: " High Cube 20ft Container",
    image: "/containspec/highcube20.webp",
    details: [
     { label: "Inside Length", value: "5.900 m / 19'4''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.311 m / 7'7''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.390 m / 7'10''", icon: FaRulerCombined },
      { label: "Door Width", value: "2.286 m / 7'6''", icon: FaRulerCombined },
      { label: "Door Height", value: "2.280 m / 7'6''", icon: FaRulerCombined },
      { label: "Capacity", value: "32.63 Cu.m / 1,150 Cft", icon: FaWeightHanging},
      { label: "Tare Weight", value: "2,300 Kgs / 5,060 Lbs", icon:FaWeightHanging },
      { label: "Max Cargo", value: "28,180 Kgs / 61,996 Lbs", icon:FaWeightHanging },
    
    
    ],
  },

  {
    title: " High Cube 40ft Container",
    image: "/containspec/highcube40.webp",
    details: [
     { label: "Inside Length", value: "12.036 m / 39'5''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.350 m / 7'8''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.697 m / 8'10''", icon: FaRulerCombined },
      { label: "Door Width", value: "2.338 m / 7'8''", icon: FaRulerCombined },
      { label: "Door Height", value: "2.585 m / 8'5''", icon: FaRulerCombined },
      { label: "Capacity", value: "76.3 Cu.m / 2,694 Cft", icon: FaWeightHanging },
      { label: "Tare Weight", value: "3,970 Kgs / 8,750 Lbs", icon:FaWeightHanging },
      { label: "Max Cargo", value: "26,510 Kgs / 58,450 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: " Platform 20ft ",
    image: "/containspec/platform20.webp",
    details: [
      { label: "Inside Length", value: "6.058 m / 19'11''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.438 m / 8'0''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.233 m / 7'4''", icon: FaRulerCombined },
       { label: "Door Width", value: " ----- ", icon: FaRulerCombined },
      { label: "Door Height", value: " ----- ", icon: FaRulerCombined },
      { label: "Capacity", value: " ----- ", icon: FaWeightHanging },
      { label: "Tare Weight", value: "2,750 Kgs / 6,061 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "24,000 Kgs / 52,896 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "platform 40ft ",
    image: "/containspec/platform40.webp",
    details: [
     { label: "Inside Length", value: "12.18 m / 40'0''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.40 m / 8'0''", icon: FaRulerCombined },
      { label: "Inside Height", value: "1.95 m / 6'5''", icon: FaRulerCombined },
       { label: "Door Width", value: " ----- ", icon: FaRulerCombined },
      { label: "Door Height", value: " ----- ", icon: FaRulerCombined },
      { label: "Capacity", value: " ----- ", icon: FaWeightHanging },
      { label: "Tare Weight", value: "2,750 Kgs / 12,783 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "39,200 Kgs / 86,397 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "Open top 20ft Container",
    image: "/containspec/opentop20.webp",
    details: [
     { label: "Inside Length", value: "5.894 m / 19'4''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.311 m / 7'7''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.354 m / 7'8''", icon: FaRulerCombined },
      { label: "Door Width", value: "2.286 m / 7'6''", icon: FaRulerCombined },
      { label: "Door Height", value: "2.184 m / 7'2''", icon: FaRulerCombined},
      { label: "Capacity", value: "32.23 Cu.m / 1,136 Cft", icon: FaWeightHanging },
      { label: "Tare Weight", value: "2,400 Kgs / 5,280 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "21,600 Kgs / 47,620 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "open Top 40ft Container",
    image: "/containspec/opentop40.webp",
    details: [
      { label: "Inside Length", value: "12.028 m / 39'5''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.350 m / 7'8''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.345 m / 8'10''", icon: FaRulerCombined },
      { label: "Door Width", value: "2.341 m / 7'8''", icon: FaRulerCombined },
      { label: "Door Height", value: "2.274 m / 8'5''", icon: FaRulerCombined },
      { label: "Capacity", value: "65,5 Cu.m / 2,694 Cft", icon: FaWeightHanging },
      { label: "Tare Weight", value: "3,850 Kgs / 8,750 Lbs", icon: FaWeightHanging},
      { label: "Max Cargo", value: "26,630 Kgs / 58,450 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "Flatrack 20ft Container",
    image: "/containspec/flatrack20.webp",
    details: [
       { label: "Inside Length", value: "5.620 m / 18'5''", icon: FaRulerCombined},
      { label: "Inside Width", value: "2.200 m / 7'3''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.233 m / 7'4''", icon:FaRulerCombined },
       { label: "Door Width", value: " ----- ", icon: FaRulerCombined },
      { label: "Door Height", value: " ----- ", icon: FaRulerCombined },
      { label: "Capacity", value: " ----- ", icon: FaWeightHanging },
      { label: "Tare Weight", value: "2,530 Kgs / 5,578 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "21,470 Kgs / 47,333 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "FlatRack 40ft Container ",
    image: "/containspec/flatrack40.webp",
    details: [
      { label: "Inside Length", value: "12.080 m / 39'7''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.438 m / 6'10''", icon:FaRulerCombined},
      { label: "Inside Height", value: "2.103 m / 6'5''", icon: FaRulerCombined },
       { label: "Door Width", value: " ----- ", icon: FaRulerCombined },
      { label: "Door Height", value: " ----- ", icon: FaRulerCombined },
      { label: "Capacity", value: " ----- ", icon: FaWeightHanging },
      { label: "Tare Weight", value: "5,480 Kgs / 12,081 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "39,000 Kgs / 85,800 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "FlatRack Collapsible 20ft",
    image: "/containspec/flatrackcollap20.webp",
    details: [
       { label: "Inside Length", value: "5.618 m / 18'6''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.208 m / 7'3''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.233 m / 7'4''", icon: FaRulerCombined },
       { label: "Door Width", value: " ----- ", icon: FaRulerCombined },
      { label: "Door Height", value: " ----- ", icon: FaRulerCombined },
      { label: "Capacity", value: " ----- ", icon: FaWeightHanging },
      { label: "Tare Weight", value: "2,750 Kgs / 6,601 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "27,730 Kgs / 61,117 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "FlatRack Collapsible 40ft ",
    image: "/containspec/flatrackcollap40.webp",
    details: [
      { label: "Inside Length", value: "12.080 m / 39'7''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.126 m / 6'10''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.043 m / 6'5''", icon: FaRulerCombined },
       { label: "Door Width", value: " ----- ", icon: FaRulerCombined },
      { label: "Door Height", value: " ----- ", icon: FaRulerCombined },
      { label: "Capacity", value: " ----- ", icon: FaWeightHanging},
      { label: "Tare Weight", value: "5,800 Kgs / 12,787 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "39,000 Kgs / 85,800 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "Reefer 20ft Container",
    image: "/containspec/reefer20.webp",
    details: [
      { label: "Inside Length", value: "5.425 m / 17'8''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.275 m / 7'5''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.260 m / 7'5''", icon: FaRulerCombined },
      { label: "Door Width", value: "2.258 m / 5''", icon: FaRulerCombined },
      { label: "Door Height", value: "2.216 m / 7'3''", icon: FaRulerCombined },
      { label: "Capacity", value: "28.3 Cu.m / 1,000 Cft", icon: FaWeightHanging },
      { label: "Tare Weight", value: "3,200 Kgs / 7,040 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "20,800 Kgs / 45,760 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "Reefer 40ft Container",
    image: "/containspec/reefer40.webp",
    details: [
     { label: "Inside Length", value: "11.557 m / 37'8''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.270 m / 7'5''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.197 m / 7'2''", icon: FaRulerCombined },
      { label: "Door Width", value: "2.282 m / 7'5''", icon: FaRulerCombined },
      { label: "Door Height", value: "2.155 m / 7'10''", icon: FaRulerCombined},
      { label: "Capacity", value: "76.3 Cu.m / 57.8 Cft", icon: FaWeightHanging },
      { label: "Tare Weight", value: "4,900Kgs / 10,780 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "25,980 Kgs / 56,561 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "Reefer 40ft High cube Container",
    image: "/containspec/reefer40highcube.webp",
    details: [
        { label: "Inside Length", value: "11.557 m / 37'11''", icon: FaRulerCombined },
      { label: "Inside Width", value: "2.294 m / 7'6''", icon: FaRulerCombined },
      { label: "Inside Height", value: "2.500 m / 8'2''", icon: FaRulerCombined },
      { label: "Door Width", value: "2.294 m / 7'6''", icon: FaRulerCombined },
      { label: "Door Height", value: "2.440 m / 8'0''", icon: FaRulerCombined },
      { label: "Capacity", value: "66.6 Cu.m / 2,344 Cft", icon: FaWeightHanging },
      { label: "Tare Weight", value: "4,500Kgs / 9,900 Lbs", icon: FaWeightHanging },
      { label: "Max Cargo", value: "25,980 Kgs / 57,561 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "Chassis 23' 5' ",
    image: "/containspec/chassis23.webp",
    details: [
      { label: " Length", value: " Lunghezza Massima - 8.30 m / Overall Extended - 27'2''", icon: FaRulerCombined }, 
 
      { label: "Tare Weight", value: "2,995 Kgs / 6,600 Lbs", icon: FaWeightHanging },

      { label: "Max Cargo", value: "17,920 Kgs / 39,500 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "Chassis 33 Tri-Axle",
    image: "/containspec/chassis33.webp",
    details: [
    { label: " Length", value: " Lunghezza Massima - 12.6 m / Overall Extended - 41'3''", icon: FaRulerCombined }, 
 
      { label: "Tare Weight", value: "4,950 Kgs / 10,900 Lbs", icon: FaWeightHanging },

      { label: "Max Cargo", value: "20,185 Kgs / 44,500 Lbs", icon: FaWeightHanging },
    ],
  },

    {
    title: "Chassis 40 GooseNeck",
    image: "/containspec/chassis40.webp",
    details: [
  { label: " Length", value: " Lunghezza Massima - 12.6 m / Overall Extended - 41'3''", icon: FaRulerCombined }, 
 
      { label: "Tare Weight", value: "2,950 Kgs / 6,500 Lbs", icon: FaWeightHanging },

      { label: "Max Cargo", value: "20,185 Kgs / 44,500 Lbs", icon: FaWeightHanging },
    ],
  },






];



